module.exports = __webpack_public_path__ + "static/img/applyBanner_m.e23ba6fa.png";